import React, { useState, useEffect} from 'react'
import { CustomTabPanel, a11yProps } from '../../../../components/Tabs';
import { Box, Paper, Tab, Tabs, ThemeProvider, Typography, createTheme } from '@mui/material';
import ProvDetail from './RemDetail';
import ProvSimple from './RemSimple';
import RemBySn from './RemBySn';
import { useFormError } from '../../../../components/Datatable/FormErrorProvider';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../components/AuthProvider';
import theme from '../../../../themeContent';

const TAB_KEY = "prov_rem_tab";

export default function OnuProv() {
    const [value, setValue] = React.useState(() => {
      const saved = parseInt(localStorage.getItem(TAB_KEY), 10);
      return Number.isInteger(saved) ? saved : 0;
    });
    const error = useFormError()
    const auth = useAuth()
    const navigate = useNavigate()
    useEffect(()=>{
      error.setErrors([])

    },[])

    const handleChange = (event, newValue) => {
      setValue(newValue);
      localStorage.setItem(TAB_KEY, newValue);
    };
    return (
      <ThemeProvider theme={theme}>
        <Paper elevation={3}>
  
          <Box sx={{ borderBottom: 1, borderColor: 'divider', p:{xs:1, sm:3} }}>
           
            <Typography variant={"h6"}>Remover ONU</Typography>
  
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              {auth.hasPerm("provisioning_service.deprovision_onu_simple") && <Tab label="Simples" {...a11yProps(0)} />}
              {auth.hasPerm("provisioning_service.deprovision_onu_detail") && <Tab label="Detalhado" {...a11yProps(1)} />}
              {auth.hasPerm("provisioning_service.deprovision_onu_detail") && <Tab label="Remover por SN" {...a11yProps(2)} />}
            </Tabs>
            <CustomTabPanel value={value} index={0}>
              <ProvSimple/>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <ProvDetail/>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <RemBySn/>
            </CustomTabPanel>
          </Box>
        </Paper>
      </ThemeProvider>
    )
  }